import {
  logToPHP,
  glsAjax,
} from './scripts';

function wantsOptIn(submittingForm, slug) {
  const el = submittingForm.find(`[name="${slug}"]`);

  if (
    typeof el !== 'undefined'
    && (
      el.val() === 'true'
      || el.is(':checked') === true
    )
  ) {
    return true;
  }

  return false;
}

// requires submittingForm to have fields first, last, email, tracking, enews, blog
async function subscribeToEveryAction(submittingForm) {
  let enews = 'N';
  let blog = 'N';
  let emailConfirm;
  let response;

  try {
    if (wantsOptIn(submittingForm, 'enews')) {
      enews = 'Y';
    }

    if (wantsOptIn(submittingForm, 'blog')) {
      blog = 'Y';
    }

    if (enews === 'N' && blog === 'N') {
      // if we're this far, no lists is probably because they were optional
      //
      return {
        success: false,
        msg: 'No subscriptions were requested. Nothing done.',
      };
    }

    emailConfirm = (submittingForm.hasClass('noEmailConfirm'))
      ? 'false'
      : 'true';
  } catch (err) {
    logToPHP(`ea_submit error. ${JSON.stringify(err)}`);
    throw err;
  }

  try {
    response = await glsAjax({
      data: {
        action: 'ea_submit',
        first: submittingForm.find('[name="first"]').val(),
        last: submittingForm.find('[name="last"]').val(),
        email: submittingForm.find('[name="email"]').val(),
        tracking: submittingForm.find('[name="tracking"]').val(),
        enews,
        blog,
        emailConfirm,
      },
    });
  } catch (err) {
    logToPHP(`ea_submit ajax error. ${JSON.stringify(err)}`);
    throw err;
  }

  if (!response.success) {
    logToPHP(`error processing ea_submit: ${response.msg}`);
    throw new Error('EA Subscription attempted but failed.');
  }

  if (response.emailConfirm) {
    return response;
  }

  return response;
}

export {
  subscribeToEveryAction,
  wantsOptIn,
};
